import { Currency } from 'types';

import { createCrudApi } from './crud.api';

export const fiatCurrencyApi = createCrudApi<Currency>('/currencies/fiat');
